const styles = {
    containerStyle: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f9f9f9"
    },
    sectionStyle: {
        width: "500px",
        height: "400px",
        border: "1px",
        borderColor: "black"
    },

    formContainer: {
        padding: "1rem",
        backgroundColor: "#f3f3f3",
        height: "300px",
        width: "400px",
        borderRadius: "10px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    loggedin: {
        olor: "#155724",
        backgroundColor: "#d4edda",
        borderColor: "#c3e6cb",
        padding: "1rem"
    }
}


export default styles;